import { useEffect, useState } from "react"
import { PageService } from "../../services/pageService"
import { useLocation } from "react-router"
import './page.scss';
import SafeHtmlRenderer from "../../providers/SafeHtmlRender";
import { LoaderSpinner } from "../commons/loader-spinner/loader-spinner";
import { SEO } from "../commons/seo/seo";

export function Page(){
    const [pageInfos,setPageInfos] = useState({});
    const location =useLocation();
    const [loading, setLoading] = useState(false);
    useEffect(()=>{
        const slug = location.pathname.split('/')[2];
        setLoading(true)
        PageService().getPage(slug).then(
            (response:any)=>{
                setPageInfos(response.data[0]);
            }
        ).catch((err:any)=>console.error(err))
        .finally(()=>{
            setLoading(false)
        })
    },[location])
    const {content,title}:any = pageInfos;

    return(
        <>
            <SEO title={`${title} — Les Toiles de la Juine`} />
            <div className="page-container">
            {loading ? (
            <LoaderSpinner visible={true} />
            ) : (
                <div>
                    <div className="section-container">
                        <h1 className="page-title">{title}</h1>
                    </div>
                    <div className='page-content section-container'>
                    {content && <SafeHtmlRenderer html={content} />}
                    </div>
                </div>
            )}
            </div>
        </>
    )
}